import React from 'react'

const Equipo = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Holden Caulfield",
      role: "UI Designer",
      image: "https://img.freepik.com/foto-gratis/retrato-joven-sonriente-gafas_171337-4842.jpg?w=2000",
      description: "Especialista en diseño de interfaces con más de 5 años de experiencia. Apasionado por crear experiencias de usuario intuitivas y atractivas.",
      skills: ["UI/UX", "Figma", "Adobe XD", "Prototipado"]
    },
    {
      id: 2,
      name: "Ninoska Blinde",
      role: "Founder",
      image: "https://www.enter.co/wp-content/uploads/2018/07/adult-beautiful-caucasian-914931-768x432.jpg",
      description: "Fundador de Bitnea con una visión clara de transformar el marketing digital. Más de 10 años de experiencia en el sector.",
      skills: ["Estrategia", "Marketing", "Liderazgo"]
    },
    {
      id: 3,
      name: "Henry Letham",
      role: "CTO",
      image: "https://image.shutterstock.com/image-photo/portrait-young-smiling-caucasian-man-260nw-1491969899.jpg",
      description: "Experto en tecnología con amplio conocimiento en desarrollo web y soluciones digitales. Lidera la innovación tecnológica en Bitnea.",
      skills: ["React", "Node.js", "DevOps", "Arquitectura"]
    }
  ];

  return (
    <section id="equipo" className="py-24 bg-gray-50 text-gray-800">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold">Nuestro Equipo</h2>
          <p className="mt-4 text-gray-600">Profesionales apasionados por el marketing digital y el desarrollo web.</p>
        </div>
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {teamMembers.map((member) => (
            <div key={member.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300">
              <img src={member.image} alt={member.name} className="w-full h-56 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold">{member.name}</h3>
                <p className="text-sm text-blue-600 mb-2">{member.role}</p>
                <p className="text-gray-700 text-sm mb-4">{member.description}</p>
                <div className="flex flex-wrap gap-2">
                  {member.skills.map((skill, i) => (
                    <span key={i} className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-xs">
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Equipo;
